if (typeof window !== "undefined") {
  window.React = require("react");
  window.ReactDOM = require("react-dom");
  window.createReactClass = require("create-react-class");

  require("./amcharts3-react.js");

  module.exports = window.AmCharts;

} else {
  module.exports = {};
}



//////////////////
// WEBPACK FOOTER
// ./~/@amcharts/amcharts3-react/index.js
// module id = 228
// module chunks = 0